var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoach360Pyramid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.714 64.871h49.1a5.714 5.714 0 010 11.315h-49.1a5.714 5.714 0 010-11.315zm8.743-33.157a5.714 5.714 0 005.714 5.715h20.186a5.714 5.714 0 000-11.329H40.114a5.714 5.714 0 00-5.657 5.614zM25.471 51.1a5.714 5.714 0 005.715 5.714h38.157a5.714 5.714 0 000-11.328h-38.2A5.714 5.714 0 0025.47 51.1z",
    fill: "url(#coach360-pyramid_svg__paint0_linear_10346_75664)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coach360-pyramid_svg__paint0_linear_10346_75664",
    x1: 34.629,
    y1: 74.682,
    x2: 64.07,
    y2: 32.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#30BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5ECCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7FD5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#93DBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ADDDD"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjUwIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjUuNzE0MyA2NC44NzE0SDc0LjgxNDNDNzcuNjMwMyA2NS4yNzI3IDc5LjcyMjUgNjcuNjg0MSA3OS43MjI1IDcwLjUyODVDNzkuNzIyNSA3My4zNzMgNzcuNjMwMyA3NS43ODQ0IDc0LjgxNDMgNzYuMTg1N0gyNS43MTQzQzIyLjg5ODIgNzUuNzg0NCAyMC44MDYxIDczLjM3MyAyMC44MDYxIDcwLjUyODVDMjAuODA2MSA2Ny42ODQxIDIyLjg5ODIgNjUuMjcyNyAyNS43MTQzIDY0Ljg3MTRaTTM0LjQ1NzEgMzEuNzE0M0MzNC40NTcxIDM0Ljg3MDIgMzcuMDE1NSAzNy40Mjg1IDQwLjE3MTQgMzcuNDI4NUg2MC4zNTcxQzYzLjE5NjUgMzcuMDUwNSA2NS4zMTcyIDM0LjYyODYgNjUuMzE3MiAzMS43NjQzQzY1LjMxNzIgMjguODk5OSA2My4xOTY1IDI2LjQ3ODEgNjAuMzU3MSAyNi4xSDQwLjExNDNDMzcuMDE5MyAyNi4xMzA1IDM0LjUxMTIgMjguNjE5NiAzNC40NTcxIDMxLjcxNDNaTTI1LjQ3MTQgNTEuMUMyNS40NzE0IDU0LjI1NTkgMjguMDI5OCA1Ni44MTQzIDMxLjE4NTcgNTYuODE0M0g2OS4zNDI5QzcyLjE4MjIgNTYuNDM2MiA3NC4zMDI5IDU0LjAxNDQgNzQuMzAyOSA1MS4xNUM3NC4zMDI5IDQ4LjI4NTYgNzIuMTgyMiA0NS44NjM4IDY5LjM0MjkgNDUuNDg1N0gzMS4xNDI5QzI4LjA0MjMgNDUuNTA4NSAyNS41MjU2IDQ3Ljk5OTggMjUuNDcxNCA1MS4xWiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzEwMzQ2Xzc1NjY0KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzEwMzQ2Xzc1NjY0IiB4MT0iMzQuNjI4NiIgeTE9Ijc0LjY4MjEiIHgyPSI2NC4wNjk1IiB5Mj0iMzIuNjM2OCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMDBCMUVGIi8+CjxzdG9wIG9mZnNldD0iMC4yMyIgc3RvcC1jb2xvcj0iIzMwQkZFOSIvPgo8c3RvcCBvZmZzZXQ9IjAuNDciIHN0b3AtY29sb3I9IiM1RUNDRTQiLz4KPHN0b3Agb2Zmc2V0PSIwLjY5IiBzdG9wLWNvbG9yPSIjN0ZENUUwIi8+CjxzdG9wIG9mZnNldD0iMC44OCIgc3RvcC1jb2xvcj0iIzkzREJERSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5QUREREQiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgCoach360Pyramid as ReactComponent };